import * as types from './constants'

const initialState = {
	email: '',
	subject: '',
	message: '',
}

const helpReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.ON_CHANGE_HELP_CONTACT:
			return {
				...state,
				[action.name]: action.value,
			}
		case types.ON_RESET:
			return initialState
		default:
			return state
	}
}

export default helpReducer
